import a from "./td-longtail-vue-components127.js";
/* empty css                              */
import n from "./td-longtail-vue-components98.js";
var i = function() {
  var e = this, r = e._self._c, s = e._self._setupProxy;
  return r(s.InputWrapper, e._b({ staticClass: "checkbox-input", attrs: { large: !1, "show-label": "", medium: !1, "inline-label": !1 }, scopedSlots: e._u([{ key: "label", fn: function({ id: t }) {
    return [r("input", e._b({ staticClass: "checkbox-input__input", class: e.inputClass, attrs: { id: t, type: "checkbox", "aria-invalid": !!e.errorMessage, "aria-describedby": `${t}-error` }, domProps: { value: e.value, checked: !!e.value }, on: { change: s.onChange } }, "input", s.inputFieldProps, !1)), r("span", { staticClass: "checkbox-input__icon" }), r("div", [e._t("default", function() {
      return [e._v(" " + e._s(e.label) + " ")];
    }), e.required && !e.hideAsterisk ? r("span", { staticClass: "input-wrapper__required" }, [e._v("*")]) : e._e()], 2)];
  } }], null, !0) }, "InputWrapper", s.inputWrapperProps, !1));
}, l = [], p = /* @__PURE__ */ n(
  a,
  i,
  l,
  !1,
  null,
  "13838836"
);
const f = p.exports;
export {
  f as default
};
